import DOMPurify from "dompurify";
import {useState} from "react";
import {IconType} from "react-icons";

import {Dropdown} from "@/components/dropdown/Dropdown.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {ActionDialog} from "@/components/overlay/ActionDialog.tsx";
// @ts-expect-error legacy
import TransactionUtils from "@/legacy/transaction/TransactionUtils.jsx";

interface StepDetailsModalProps {
  stepDetails?: string;
  icon: IconType;
  text: string;
}

export const StepDetailsModalDropdownIcon = ({stepDetails, icon, text}: StepDetailsModalProps) => {
  const [showModal, setShowModal] = useState(false);
  if (!stepDetails) {
    return null;
  }
  const innerHTML = TransactionUtils.formatStepDetails(stepDetails);
  return (
    <div className="browser-console-output btn-group dropup">
      <ActionDialog
        onConfirm={() => setShowModal(false)}
        size="xl"
        title="Request Details"
        show={showModal}
        confirmBtnText="OK"
        onCancel={() => setShowModal(false)}
        hasCancelButton={false}
      >
        <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(innerHTML)}} />
      </ActionDialog>
      <Dropdown.Item
        onClick={() => {
          setShowModal(true);
        }}
      >
        <div className="d-flex align-items-center">
          <Icon icon={icon} className="me-1" />
          {text}
        </div>
      </Dropdown.Item>
    </div>
  );
};
